import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-accent py-20 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 geometric-flow opacity-90"></div>
      <div className="absolute inset-0 bg-black/20"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
            <Icon name="MessageCircle" size={20} className="text-white" />
            <span className="text-white font-medium">Let's Connect</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 font-heading">
            Start Your
            <span className="block text-accent">Transformation Journey</span>
          </h1>
          
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Ready to prove your mettle? Connect with our experts through multiple channels designed to understand your unique challenges and accelerate your path to success.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="default" 
              size="lg"
              className="bg-white text-primary hover:bg-white/90 font-semibold px-8 py-4"
            >
              <Icon name="Calendar" size={20} className="mr-2" />
              Schedule Consultation
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="border-white text primary hover:bg-white/10 font-semibold px-8 py-4"
            >
              <Icon name="Phone" size={20} className="mr-2" />
              Call Now: +91 (555) 123-4567
            </Button>
          </div>
        </div>
      </div>
      
      {/* Floating Elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-accent/20 rounded-full blur-2xl animate-pulse delay-1000"></div>
    </section>
  );
};

export default ContactHero;